"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addScore = exports.renderTooltip = exports.setTooltip = exports.decrementStatuses = exports.castWaterHands = exports.castIceArmor = exports.renderStatuses = exports.renderMenuItems = exports.countPetsLeft = exports.setMessage = exports.drawAll = exports.reset = exports.getLastMessage = exports.tryDamageHouse = exports.addExp = exports.addGold = exports.addSkillPoint = exports.getStats = exports.useAscii = void 0;
var entitiesUtils_sidecar_1 = require("../../../entities/entitiesUtils-sidecar");
var rando_sidecar_1 = require("../../../lib/rando-sidecar");
var rogueAanimManager_sidecar_1 = require("../anims/rogueAanimManager-sidecar");
var rogueSpellData_sidecar_1 = require("../anims/rogueSpellData-sidecar");
var rogueSpellDestoyHouse_sidecar_1 = require("../anims/rogueSpellDestoyHouse-sidecar");
var rogueCamera_sidecar_1 = require("../camera/rogueCamera-sidecar");
var rogueInput_1 = require("../input/rogueInput");
var rogueInput_sidecar_1 = require("../input/rogueInput-sidecar");
var rogueItems_sidecar_1 = require("../items/rogueItems-sidecar");
var rogueMonofont_1 = require("../monofont/rogueMonofont");
var rogueMonofont_sidecar_1 = require("../monofont/rogueMonofont-sidecar");
var rogueMonsters_sidecar_1 = require("../monsters/rogueMonsters-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueTester_7drl_2023_1 = require("../scene/rogueTester_7drl_2023");
var rogueStats_sidecar_1 = require("./rogueStats-sidecar");
var rogueUiCast_sidecar_1 = require("./rogueUiCast-sidecar");
var rogueUiHelp_sidecar_1 = require("./rogueUiHelp-sidecar");
var rogueUiInventory_sidecar_1 = require("./rogueUiInventory-sidecar");
var rogueUiMessages_sidecar_1 = require("./rogueUiMessages-sidecar");
var rogueUiStory_sidecar_1 = require("./rogueUiStory-sidecar");
var rogueUiUpgrades_sidecar_1 = require("./rogueUiUpgrades-sidecar");
var _stats = {
    useAscii: false,
    fireTimer: 10,
    maxFireTimer: 10,
    gold: 1234,
    playerExpLevel: 1,
    depth: 1,
    exp: 0,
    score: 0,
    skillPoints: 0,
    messages: [],
    tooltip: '',
    tooltipX: 0,
    tooltipY: 0,
    iceArmorStrength: 0,
    iceArmorTimer: 0,
    waterHandsTimer: 0,
};
var useAscii = function () {
    return _stats.useAscii;
};
exports.useAscii = useAscii;
var getStats = function () {
    return _stats;
};
exports.getStats = getStats;
var addSkillPoint = function () {
    _stats.skillPoints++;
};
exports.addSkillPoint = addSkillPoint;
var addGold = function (amount) {
    _stats.gold += amount;
};
exports.addGold = addGold;
var addExp = function (amount) {
    _stats.exp += amount;
    if (_stats.exp >= 5) {
        _stats.exp -= 5;
        _stats.playerExpLevel++;
        (0, exports.setMessage)('You reached level ' + _stats.playerExpLevel + '!');
    }
};
exports.addExp = addExp;
var tryDamageHouse = function (amount) {
    var h = (0, rogueTester_7drl_2023_1.getHouse)();
    if (h) {
        if (h.hp > 0) {
            var isHurt = rando_sidecar_1.rando.chance(h.difficulty.houseDamageChance);
            if (isHurt) {
                h.hp -= amount;
                (0, exports.setMessage)('The house is damaged!');
                if (h.hp <= 0) {
                    h.hp = 0;
                    (0, exports.setMessage)('The house is destroyed!');
                    rogueAanimManager_sidecar_1.rogueAanimManager.addAnim(rogueSpellDestoyHouse_sidecar_1.rogueSpellDestoyHouse.rogueAnim());
                }
            }
        }
    }
};
exports.tryDamageHouse = tryDamageHouse;
var getLastMessage = function (oy) {
    return _stats.messages[_stats.messages.length - 1 - oy] || '';
};
exports.getLastMessage = getLastMessage;
var reset = function () {
    _stats.maxFireTimer = 10;
    _stats.fireTimer = _stats.maxFireTimer;
    _stats.gold = 0;
    _stats.exp = 0;
    _stats.playerExpLevel = 1;
    _stats.depth = 1;
    _stats.score = 0;
    _stats.skillPoints = 3;
    _stats.messages = [];
    rogueSpellData_sidecar_1.rogueSpellData.resetSpellData();
};
exports.reset = reset;
var drawAll = function () {
    var calculateTicks = function (num, oneText, zeroText, colors) {
        if (oneText === void 0) { oneText = 'x'; }
        if (zeroText === void 0) { zeroText = ''; }
        if (colors === void 0) { colors = []; }
        var ticks = '';
        if (num <= 0) {
            return zeroText;
        }
        if (num === 1) {
            return oneText;
        }
        var idx = 0;
        for (var i = num; i > 0;) {
            if (colors.length > 0) {
                ticks += "[color:".concat(entitiesUtils_sidecar_1.entitiesUtils.wrappedGet(colors, idx), "|");
            }
            idx++;
            if (i > 10) {
                i -= 10;
                ticks += 'X';
            }
            else {
                i -= 1;
                ticks += 'x';
            }
            if (colors.length > 0) {
                ticks += ']';
            }
        }
        return ticks;
    };
    // rogueMonofont.write(0, 0, 'Hello Rogue!')
    var x = 1;
    var y = 20;
    // rogueMonofont.write(x, y, '$' + _stats.gold)
    var fireTimer = '';
    // let colors = ['red', 'yellow', 'orange']
    var maxFireTimer = 10;
    var xs = 2;
    x = xs;
    // rogueMonofont.write(x, y, 'Depth:' + rogueMaps.getCurrentMap()?.dungeonLevel)
    var hp = 0;
    var maxHp = 0;
    var p = rogueMonsters_sidecar_1.rogueMonsters.getPlayer();
    if (p) {
        // x += 8
        // rogueMonofont.write(x, y, 'Level:' + _stats.level + ' Exp:' + _stats.exp)
        hp = p.hp;
        maxHp = p.maxHp;
    }
    x += 2;
    rogueMonofont_sidecar_1.rogueMonofont.writeWrapped(x, y, 30, 'Hp:' +
        calculateTicks(hp, '[orange|Critical]', '[red|Deceased]', rogueMonofont_1.healthScale) +
        ''); // hp + '/' + maxHp)
    x = xs;
    y++;
    rogueMonofont_sidecar_1.rogueMonofont.writeWrapped(x, y, 30, 'Fire:[fire|' + calculateTicks(_stats.fireTimer, 'Will Grow') + ']');
    x += 18;
    var houseHp = 0;
    var houseHpIndicator = '';
    var h = (0, rogueTester_7drl_2023_1.getHouse)();
    if (h) {
        houseHp = h.hp;
    }
    rogueMonofont_sidecar_1.rogueMonofont.writeWrapped(x, y, 30, 'House:[lightBlue|' + calculateTicks(houseHp, 'Danger', 'Destroyed') + ']');
    y--;
    x = xs + 10 + 7 + 2;
    var pets = '';
    rogueMonsters_sidecar_1.rogueMonsters.getAll().forEach(function (m) {
        if (m && !m.isDead && m.data.isFriendly && !m.data.isPlayer) {
            if (m.isSaved) {
                pets += "[green|".concat(m.data.char, "]");
            }
            else {
                pets += m.data.char + '';
            }
        }
        if (m && m.data.isHellHound) {
            pets += "[fire|".concat(m.data.char, "]");
        }
    });
    rogueItems_sidecar_1.rogueItems.getAll().forEach(function (i) {
        if (i && !i.isDead && i.data.isPetCorpse) {
            pets += '[black|x]';
        }
    });
    rogueMonofont_sidecar_1.rogueMonofont.writeWrapped(x, y, 30, 'Pets:' + pets);
    y += 3;
    x = 0;
    rogueMonofont_sidecar_1.rogueMonofont.write(x, y, (0, exports.getLastMessage)(0));
    y += 1;
    rogueMonofont_sidecar_1.rogueMonofont.write(x, y, (0, exports.getLastMessage)(1));
    y += 1;
    rogueMonofont_sidecar_1.rogueMonofont.write(x, y, (0, exports.getLastMessage)(2));
    x = 0;
    y = -2;
    rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'Fire Fighing Wizard Pet Rescue RL', rogueDef_sidecar_1.rogueDef.colors.light);
    x = rogueDef_sidecar_1.rogueDef.screenWidth - 9 - 3;
    y = rogueDef_sidecar_1.rogueDef.screenHeight - 4;
    rogueMonofont_sidecar_1.rogueMonofont.writeWrapped(x, y, 30, 'House ' + _stats.depth + '/10');
    y += 3;
    rogueMonofont_sidecar_1.rogueMonofont.write(x, y, 'Score:' + _stats.score);
    (0, exports.renderMenuItems)();
    (0, exports.renderStatuses)();
};
exports.drawAll = drawAll;
var setMessage = function (message) {
    _stats.messages.push(message);
    if (_stats.messages.length > 10) {
        _stats.messages.shift();
    }
    // _stats.lastMessage = message
};
exports.setMessage = setMessage;
var countPetsLeft = function () {
    var count = 0;
    rogueMonsters_sidecar_1.rogueMonsters.getAll().forEach(function (m) {
        if (m && !m.isDead && m.data.isFriendly && !m.data.isPlayer) {
            if (!m.isSaved) {
                count++;
            }
        }
    });
    return count;
};
exports.countPetsLeft = countPetsLeft;
var renderMenuItems = function () {
    var y = 0;
    var x = 1;
    var renderMenuItem = function (label, cb) {
        x +=
            rogueMonofont_sidecar_1.rogueMonofont.write(x, y, label, rogueDef_sidecar_1.rogueDef.colors.light, rogueDef_sidecar_1.rogueDef.colors.dark, cb) + 1;
    };
    renderMenuItem('Inv', function () {
        if (rogueUiInventory_sidecar_1.rogueUiInventory.isOpen()) {
            rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_1.EInputCommand.cancel);
        }
        else {
            rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_1.EInputCommand.openInventory);
        }
    });
    renderMenuItem('Cast', function () {
        if (rogueUiCast_sidecar_1.rogueUiCast.isOpen()) {
            rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_1.EInputCommand.cancel);
        }
        else {
            rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_1.EInputCommand.openCastMenu);
        }
    });
    renderMenuItem('Upg', function () {
        if (rogueUiUpgrades_sidecar_1.rogueUiUpgrades.isOpen()) {
            rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_1.EInputCommand.cancel);
        }
        else {
            rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_1.EInputCommand.openUpgradesMenu);
        }
    });
    renderMenuItem('Msgs', function () {
        if (rogueUiMessages_sidecar_1.rogueUiMessages.get().isOpen) {
            rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_1.EInputCommand.cancel);
        }
        else {
            rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_1.EInputCommand.openMessages);
        }
    });
    renderMenuItem('Help', function () {
        if (rogueUiHelp_sidecar_1.rogueUiHelp.get().isOpen) {
            rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_1.EInputCommand.cancel);
        }
        else {
            rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_1.EInputCommand.openHelp);
        }
    });
    renderMenuItem('Story', function () {
        if (rogueUiStory_sidecar_1.rogueUiStory.get().isOpen) {
            rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_1.EInputCommand.cancel);
        }
        else {
            rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_1.EInputCommand.openStory);
        }
    });
    renderMenuItem('+', function () {
        rogueCamera_sidecar_1.rogueCamera.setZoomOffset(1);
    });
    x--;
    renderMenuItem('-', function () {
        rogueCamera_sidecar_1.rogueCamera.setZoomOffset(-1);
    });
    var useAscii = rogueStats_sidecar_1.rogueStats.useAscii();
    renderMenuItem(useAscii ? 'Tiles' : 'Ascii', function () {
        rogueInput_sidecar_1.rogueInput.setNextInputCommand(rogueInput_1.EInputCommand.switchGraphics);
    });
};
exports.renderMenuItems = renderMenuItems;
var renderStatuses = function () {
    var y = rogueDef_sidecar_1.rogueDef.screenHeight - 1;
    var x = 1;
    var renderStatus = function (label, tooltip) {
        x +=
            rogueMonofont_sidecar_1.rogueMonofont.write(x, y, label, rogueDef_sidecar_1.rogueDef.colors.light, rogueDef_sidecar_1.rogueDef.colors.dark, function () { }, function () {
                (0, exports.setTooltip)(tooltip);
            }) + 1;
    };
    if (_stats.iceArmorStrength > 0) {
        renderStatus('Ice Armor ' + _stats.iceArmorStrength + '/' + _stats.iceArmorTimer, 'Protects you from fire damage');
    }
    if (_stats.waterHandsTimer > 0) {
        renderStatus('Water Hands ' + _stats.waterHandsTimer, 'Allows you to extinguish fires easier');
    }
};
exports.renderStatuses = renderStatuses;
var castIceArmor = function () {
    (0, exports.setMessage)('You are covered in frost!');
    _stats.iceArmorStrength = rogueSpellData_sidecar_1.rogueSpellData.getSpellStats('ice-armor').protection;
    _stats.iceArmorTimer = rogueSpellData_sidecar_1.rogueSpellData.getSpellStats('ice-armor').duration;
};
exports.castIceArmor = castIceArmor;
var castWaterHands = function () {
    (0, exports.setMessage)('Your hands are now damp?');
    _stats.waterHandsTimer = rogueSpellData_sidecar_1.rogueSpellData.getSpellStats('water-hands').duration;
};
exports.castWaterHands = castWaterHands;
var decrementStatuses = function () {
    _stats.iceArmorTimer--;
    if (_stats.iceArmorTimer <= 0) {
        _stats.iceArmorStrength = 0;
    }
    _stats.waterHandsTimer--;
};
exports.decrementStatuses = decrementStatuses;
var setTooltip = function (tooltip, x, y) {
    if (x === void 0) { x = 1; }
    if (y === void 0) { y = rogueDef_sidecar_1.rogueDef.screenHeight - 2; }
    _stats.tooltip = tooltip;
    _stats.tooltipX = x;
    _stats.tooltipY = y;
    // _stats.tooltipTimer = 2
};
exports.setTooltip = setTooltip;
var renderTooltip = function () {
    if (!_stats.tooltip) {
        return;
    }
    // let x = 1
    // let y = rogueDef.screenHeight - 2
    rogueMonofont_sidecar_1.rogueMonofont.write(_stats.tooltipX, _stats.tooltipY, _stats.tooltip, rogueDef_sidecar_1.rogueDef.colors.light, rogueDef_sidecar_1.rogueDef.colors.dark, null, null, '', '');
    _stats.tooltip = '';
};
exports.renderTooltip = renderTooltip;
function addScore(score) {
    (0, exports.getStats)().score += score;
}
exports.addScore = addScore;
